import apiWrapper from '@/utils/apiHelpers/apiWrapper'
import { getPublications } from '@/utils/publications/helpers'
import { pageActions } from '@/store/page'
import headerHelper from '@/store/helpers/headerHelper'
import { generalConstants } from '@tweddle-se-team/common/constants'

const { DFOM } = generalConstants

const serverSideDataNordics = async (store, ctx, { filters, publications, isPreview = false }) => {
  const { brand, model, modelType, year, language } = filters
  await headerHelper.setHeaderModel(store, { brand, model, modelType, year, language })
  store.dispatch(pageActions.SET_TITLE(`${year} ${model}`))

  const digitalFirstOwnerManual = publications.items.find(pub => pub.publicationType === DFOM && !!pub.contents?.ditaId)
  let baseDFOMEngPublication = language === 'en' ? digitalFirstOwnerManual : null
  let hotspots = {}

  if (digitalFirstOwnerManual) {
    const hotspotFilters = { brand, model, modelType, year }
    const queryParams = { page: 0, limit: 0, filters: JSON.stringify(hotspotFilters) }
    if (!isPreview) {
      queryParams.isPublished = true
    }
    const { data } = await apiWrapper.get('hotspots', queryParams, apiWrapper.getHeaders(ctx))
    hotspots = data?.[0]

    if (isPreview && hotspots?.draftMapping) {
      hotspots = {
        ...hotspots,
        mapping: hotspots.draftMapping
      }
    }

    if (!baseDFOMEngPublication) {
      const result = await getPublications({ ...filters, language: 'en', publicationType: DFOM }, {}, ctx)
      baseDFOMEngPublication = result?.items?.[0]
    }
  }

  return {
    props: {
      publications,
      hotspots,
      baseDFOMEngPublication,
      digitalFirstOwnerManual,
      vehicleData: null,
      ...(isPreview && { isPreviewMode: true })
    }
  }
}

export default serverSideDataNordics
